
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import Cookies from "js-cookie";
import { toast } from "react-toastify";
import { GMB } from "../../services/gmbApiConfig";

// fetches the store details for a store id
export const fetchStoreDetails = createAsyncThunk(
  "store/fetchStoreDetails",
  async (storeCode, { dispatch, rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${GMB.ENDPOINTS.LOCATION_DATA.GET_LOC_DATA}`,
        { store_code: Number(storeCode) },
        {
          headers: {
            Authorization: Cookies.get("ssp_sso_token"),
            "content-type": "application/json",
          },
        },
      );

      if (response.data?.message?.includes("No data found")) {
        toast.error(response.data?.message);
        return rejectWithValue(response.data.message);
      }
      if (response.data?.status === "invalid_login") {
        toast.error("Please Login again Session is Expired!!!");
        return rejectWithValue(
          response.data.error_message || response.data.message,
        );
      }
      if (response.data?.status === "error") {
        toast.error("Something went wrong");
        return rejectWithValue(
          response.data.error_message || response.data.message,
        );
      }

      return response.data.body[0];
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

// fetches all the store codes and store names
// export const fetchStoreCodes = createAsyncThunk(
//   "store/fetchStoreCodes",
//   async ({ verified }, { rejectWithValue }) => {
//     try {
//       console.log("dispatch for store codes ::", verified);
//       const response = await axios.get(
//         `${GMB.ENDPOINTS.LOCATION_DATA.GET_ALL_LOC_DATA}`,
//         {
//           headers: {
//             Authorization: Cookies.get("ssp_sso_token"),
//             "content-type": "application/json",
//           },
//         },
//       );

//       return response.data.body;
//     } catch (error) {
//       return rejectWithValue(error.message);
//     }
//   },
// );
export const fetchStoreCodes = createAsyncThunk(
  "store/fetchStoreCodes",
  async (filters, { rejectWithValue }) => {
    try {
     
      let url = `${GMB.ENDPOINTS.LOCATION_DATA.GET_ALL_LOC_DATA}`;
      // console.log("URLLL ::: ",url)

      // Check if any filters are set and append query parameters
      // const params = new URLSearchParams();
      // if (filters?.verified !== null) {
      //   params.append("is_verified", filters.verified);
      // }
      // if (filters?.rating !== null) {
      //   params.append("average_rating", filters.rating);
      // }

      // // Append query parameters to the URL if any exist
      // if (params.toString()) {
      //   url = `${url}?${params.toString()}`;
      // }

      if (filters && (filters.verified !== null || filters.rating !== null)) {
        const params = new URLSearchParams();
        if (filters.verified !== null) params.append("is_verified", filters.verified);
        if (filters.rating !== null) params.append("average_rating", filters.rating);

        url = `${url}?${params.toString()}`;
      }

      const response = await axios.get(url, {
        headers: {
          Authorization: Cookies.get("ssp_sso_token"),
          "content-type": "application/json",
        },
      });

      return response.data.body;
    } catch (error) {
      console.error("Error fetching store codes:", error.message);
      return rejectWithValue(error.message);
    }
  }
);



const gmbStoreSlice = createSlice({
  name: "gmbStore",
  initialState: {
    storeCodes: [],
    storeDetail: null,
    isLoading: false,
    error: null,
    isEditing: false,
    isStoreVerified: false,
  },
  reducers: {
    setEditing(state, action) {
      state.isEditing = action.payload;
    },
    setIsStoreVerified(state, action) {
      state.isStoreVerified = action.payload;
    },
    resetStoreDetail(state) {
      state.storeDetail = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // fetchStoreDetails
      .addCase(fetchStoreDetails.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchStoreDetails.fulfilled, (state, action) => {
        state.isLoading = false;
        state.storeDetail = action.payload;
      })
      .addCase(fetchStoreDetails.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      // fetchStoreCodes
      .addCase(fetchStoreCodes.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchStoreCodes.fulfilled, (state, action) => {
        state.isLoading = false;
        state.storeCodes = action.payload;
      })
      .addCase(fetchStoreCodes.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
  },
});

export const { setEditing, isLoading,setIsStoreVerified,isStoreVerified,resetStoreDetail } = gmbStoreSlice.actions;

export const selectAccountId = (state) => state.gmbStore.storeDetail?.account_id;
export const selectLocationId = (state) => state.gmbStore.storeDetail?.location_id;

export const selectStoreDetails = (state) => state.gmbStore.storeDetail;

export default gmbStoreSlice.reducer;
